<template>
<div>

    <!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    Tab Container
    * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *  -->
    <div class="tabs">
        <div class="tab-header-wrapper">
            <ul class="tab-header">



    <!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    Tab Buttons
    * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *  -->
                <li v-for="category in formData" class="tab-trigger" :class="{active:isActive(category)}" @click="updateSelect(category.name)">
                    <a>{{ category.categoryTitle }}</a>
                </li>

            </ul>
        </div>

        <!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    Tab Details
    * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *  -->
        <div class="tab-details" style="padding: 0;">

            <div v-for="category in formData" class="tab" style="padding: 0;" :class="{'is-active': selectedTab === category.name}">

                <div v-for="option in category.options" class="radio radio-primary">
                    <input type="radio" name="investor_status" :value="option.value" :checked="option.value == selectedRadio" required>
                    <label>{{ option.text }}</label>
                </div>
            </div>
        </div>

    </div>
</div>
</template>

<script>
import formData from './entityFormData.js'

export default {

    props: {
        selectedRadio: {
            default: ''
        }
    },

    data() {
        return {
            selectedTab: formData[0].name,
            formData: formData
        }
    },

    methods: {
        updateSelect(selectedTab) {
            this.selectedTab = selectedTab
        },
        isActive(category) {
            return this.selectedTab == category.name;
        }
    },
    
    mounted() {
        let self = this;
        formData.forEach(function(tab) {
            tab.options.forEach(function(option){
                if (option.value == self.selectedRadio) {
                    self.updateSelect(tab.name);
                }
            });
        });
    }
}
</script>
